/**
 * ดันถอย (push): moves that drive the one struck back across the ring, through a guard too (kit audit 2026-10-13 piece 10,
 * docs/design/combat/2026-10-13-art-kit-audit.md; user Q2: cliff-push-sabre = push / ring-out instead of bleed). The guard
 * still cuts the damage (the user's guard rule); it does not hold the ground. The bout's own small shove (DUEL_V2.knock) stays
 * and this comes on top. Read by systems/duelPush.ts, in a bout's fight only; a fighter in armour, thrown, down or in a lock
 * form is not pushed. The ring-out itself is the bout's rule (systems/duelRingOut.ts). Starting numbers, ns-balance tunes.
 */
export interface PushDef {
  /** Metres the struck fighter is driven back when the blow lands (hit, interrupt, a broken or shattered guard). */
  readonly hit: number;
  /** Metres when the blow is guarded. */
  readonly blocked: number;
}

export const DUEL_PUSH = {
  /** The push plays out over this long (s), at an even pace. */
  time: 0.22,
} as const;

/** Skill id -> its push. */
export const PUSH_MOVES: Readonly<Record<string, PushDef>> = {
  // ดาบผลักผาชาด: every heavy cut gives ground to the cliff's edge
  'rc-edge': { hit: 0.5, blocked: 0.3 },
  'rc-split': { hit: 1.2, blocked: 0.6 },
  'rc-tide': { hit: 1.2, blocked: 0.5 },
  'rc-hunt': { hit: 2.0, blocked: 0.9 },
};

export function pushOf(skillId: string): PushDef | null {
  return PUSH_MOVES[skillId] ?? null;
}
